export default "__VITE_ASSET__DtD$JbAw__"